import React from "react";
import { withRouter } from "react-router-dom";
import Presenter from "./Presenter";
import qs from "qs";
import Moment from "moment";

import { useQuery } from "react-apollo-hooks";
import { STORE_DELIVERY_ORDER_LIST_QUERY } from "../Queries";

export default withRouter(({ history, match, location }) => {
  const queryString = qs.parse(location.search.substr(1));

  const startDate = queryString.startDate
    ? queryString.startDate
    : "2023-10-01";
  const endDate = queryString.endDate
    ? queryString.endDate
    : Moment().add(1, "d").format("YYYY-MM-DD");
  const deliveryDeliver_id = queryString.deliveryDeliver_id
    ? queryString.deliveryDeliver_id
    : "";
  const deliveryBox_id = queryString.deliveryBox_id
    ? queryString.deliveryBox_id
    : "";
  const page = queryString.page ? +queryString.page : 1;
  const take = 15;
  const baseUrl = "/delivery/deliveryOrders";

  const { data, loading, error } = useQuery(STORE_DELIVERY_ORDER_LIST_QUERY, {
    fetchPolicy: "network-only",
    variables: {
      take,
      skip: (page - 1) * take,
      startDate,
      endDate,
      deliveryDeliver_id,
      deliveryBox_id,
    },
  });

  // if (loading) {
  //   return <></>;
  // }
  if (error) {
    var message = error.toString();
    message = message.replace("Error: GraphQL error:", "");
    return <>{message}</>;
  }

  return (
    <Presenter
      history={history}
      match={match}
      location={location}
      startDate={startDate}
      endDate={endDate}
      deliveryDeliver_id={deliveryDeliver_id}
      deliveryBox_id={deliveryBox_id}
      page={page}
      take={take}
      loading={loading}
      data={data}
      baseUrl={baseUrl}
    />
  );
});
